import { useWindowWidth } from '@prishapolicy/shared/ui'
import Image from 'next/image'
import group from './Group.png'
import Sheet from './Sheet.png'

interface SuretyBondCardsProps {
    title: string;
    description: string;
    imageUrl: any;
    theme: string
}

export const SuretyBondCardsData: SuretyBondCardsProps[] = [
    {
        description: "A surety bond is a contract between three parties: the surety, the principal, and the obligee. It is used as promise that an insurer will fulfill the financial obligation of the project owner/principal, arising from the contractor’s/obligee’s non-performance or breach of the agreed contractual obligation. The organization making this promise is called the surety or guarantor.  ",
        imageUrl: Sheet,     
        title: "What Is a Surety? ",
        theme: "green"
    },
    {
        description: "Though surety bonds are issued for various purposes globally. In India, Any contractor / business owner who qualifies and can execute a contract / project / supply of machinery but is  required to provide security to the Beneficiary / Project owners at the time of bidding, performance, or the payment stage of the contract, can obtain this bond.  ",
        imageUrl: group,
        title: "Who can buy Surety Bond?  ",
        theme: "blue"
    },

]

export const SuretyBondCards = ({ title, description, imageUrl, theme }: SuretyBondCardsProps) => {
    const { isLg } = useWindowWidth();
    return (
        <div className={`border rounded-xl hover:bg-surface-${theme}  hover:border-${theme}-200 border-grey-200 w-full`}>
            <div className="flex gap-6 justify-between items-center  h-full py-8 pl-8 pr-8 lg:pr-0">
                <div className="flex  flex-col gap-2 ">
                    <h1 className="text-title-4 font-bold">{title}</h1>
                    <h1 className="text-title-7 font-normal">{description}</h1>
                </div>
                {
                    isLg && <Image src={imageUrl} alt={title} height={210} className='object-contain' />
                }

            </div>
        </div>
    )
}